module.exports = __webpack_public_path__ + "static/media/Icons_share.0a8a2f08.svg";